"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.action = void 0;
const mithril_1 = __importDefault(require("mithril"));
// A Simple action link
const action = (content, cb) => {
    return (0, mithril_1.default)("a", { href: "#", onclick: (evt) => { evt.preventDefault(); cb(evt); } }, content);
};
exports.action = action;
